import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate';
import { useAdminContext } from '../../../context/adminContext';
import { addOrUpdateJobApi, addOrUpdateJobCategoryApi, changePartnerEarningWithdrawRequestStatusApi, cityByCountryApi, countryListApi, getJobCategoryApi, getJobListApi, partnerEarningWithdrawRequestApi, removeJobCategoryApi } from '../../../utils/ApiEndpointFunctions';
import { capitalizeWords } from '../../../utils/HelperFuncitons';

import CommonTable from '../../common/Table/CommonTable'
import ConfirmationModal from '../../common/ConfirmationModal';
import toast from 'react-hot-toast';
import { useFormik } from 'formik';

import { jobCategoryIntialValue, jobCategoryValidationSchema, jobInitialValue, jobValidationSchema } from '../../common/Validation';

import AddOrUpdateJobCategory from './AddOrUpdateJobCategory';


const JobCategory = () => {
  const [loader, setLoader] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [confirmStatus, setConfirmStatus] = useState({ status: "", id: 0 })
  
  const addOrUpdateJobCategoryModalId = "addOrUpdateJobCategoryModal";
  const [submitLoader, setSubmitLoader] = useState(false);
  



  const confirmApproveOrReject = (status, id) => {
    setConfirmStatus({ status, id })
    document.getElementById('confirmModalBtn').click()
  }

  const getAllJobList = async (selectedPage, limit) => {
    try {
      setLoader(true);

      const res = await getJobCategoryApi()
      if (res.status === 200 || res.status === 201) {
        setTableData(res?.data?.data);
        setLoader(false);
      }
    } catch (error) {
      console.log(error)
    }
    setLoader(false)
  }

   const removeJobHandler = async(id)=>{
    try {

      const res = await removeJobCategoryApi({id})
     
      if(res.status===200 && res.data.status === 1){
        toast.success(res.data.message)
         getAllJobList()
      }

    } catch (error) {
      console.log("something went wrong while deleting job category: ",error.message)
    }
  }


  const headerData = [
    { name: "S.NO", className: "col-1", key: "sNo" },
    { name: "Name", className: "col-1", key: "categoryName" },
    { name: "Description", className: "col-1", key: "description" },
    { name: "Action", className: "col-1", key: "action" },
  ]

  const RequestTableData = tableData.map((item, index) => ({
    sNo: index + 1,
    categoryName: item?.categoryName ? capitalizeWords(item?.categoryName) : "-",
    description: item?.description ? item?.description : "-",
    action:
      <div className="dropdown">
        <button
          className=" border-0 bg-white"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-three-dots-vertical"
            viewBox="0 0 16 16"
          >
            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
          </svg>
        </button>
        <ul
          className="dropdown-menu"
          style={{ zIndex: "1000" }}
        >
          <li className="dropdown-item"
            onClick={() => { formik.setValues(item); }}
            data-bs-toggle="modal"
            data-bs-target={`#${addOrUpdateJobCategoryModalId}`}
          >
            <div style={{ cursor: "pointer" }}
            >
              Edit
            </div>
          </li>
           <li className="dropdown-item" 
            onClick={() => { removeJobHandler(item.id) }}
            // data-bs-toggle="modal"
            // data-bs-target={`#${addOrUpdateJobModalId}`}
          >
            <div style={{ cursor: "pointer" }}
            >
              Delete
            </div>
          </li>
        </ul>
      </div>
  }))

  const handleChangeStatus = async () => {
    try {
      setLoader(true)
      await changePartnerEarningWithdrawRequestStatusApi(confirmStatus)
      getAllJobList();
      document.getElementById('confirmationModal').click()
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something Went Wrong")
      setLoader(false)
    }
  }

  const formik = useFormik({
    initialValues: jobCategoryIntialValue,
    onSubmit: async (values) => {
      try {
        setSubmitLoader(true)
        const res = await addOrUpdateJobCategoryApi(values)
        if (res.status === 200 || res.status === 201) {
          toast.success(res.data.message)
          getAllJobList()
          document.getElementById(addOrUpdateJobCategoryModalId).click()
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something Went Wrong")

      }
      setSubmitLoader(false)
    },
    validationSchema: jobCategoryValidationSchema
  })

  useEffect(() => {
    getAllJobList();

  }, [])

  return (

    <>
      <>
        <div className="card">
          <div className="d-flex justify-content-end flex-wrap align-items-center mt-3 mt-lg-0 py-4">
            <div style={{ display: "-webkit-inline-box" }} className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target={`#${addOrUpdateJobCategoryModalId}`}
                onClick={formik.resetForm}
              >
                Add
              </button>
            </div>
          </div>
          <CommonTable headers={headerData} data={RequestTableData} loading={loader} />
        </div>
      </>


      <button
        className="d-none"
        id="confirmModalBtn"
        data-bs-toggle="modal"
        data-bs-target="#confirmationModal">
        openmodal
      </button>
      <ConfirmationModal
        handleConfirm={handleChangeStatus}
        confirmStatus={confirmStatus}
        message={"Are You Sure?"}
      />

      <AddOrUpdateJobCategory formik={formik} loading={submitLoader} modalId={addOrUpdateJobCategoryModalId} />
    </>

  )
}




export default JobCategory